import { api } from "@/lib/api";

export async function listTemplates() {
  const { data } = await api.get("/campaigns/templates");
  return data.templates;
}

export async function listOwnCampaigns(productId) {
  const q = productId ? `?product_id=${productId}` : "";
  const { data } = await api.get(`/campaigns${q}`);
  return data.items;
}

export async function getOwnCampaign(id) {
  const { data } = await api.get(`/campaigns/${id}`);
  return data.campaign;
}

export async function createCampaign(payload) {
  const { data } = await api.post("/campaigns", payload);
  return data.campaign;
}

export async function updateCampaign(id, payload) {
  const { data } = await api.patch(`/campaigns/${id}`, payload);
  return data.campaign;
}

export async function deleteCampaign(id) {
  await api.delete(`/campaigns/${id}`);
}

export async function openCampaign(id) {
  const { data } = await api.post(`/campaigns/${id}/open`);
  return data.campaign;
}

export async function closeCampaign(id) {
  const { data } = await api.post(`/campaigns/${id}/close`);
  return data.campaign;
}

export async function getPublicCampaign(id) {
  const { data } = await api.get(`/campaigns/public/${id}`);
  return data.campaign;
}

export async function listOpenCampaignsForProduct(productId) {
  const { data } = await api.get(`/campaigns/public?product_id=${productId}`);
  return data.items;
}

export async function submitFeedback(campaignId, answers) {
  const { data } = await api.post(`/campaigns/${campaignId}/submit`, { answers });
  return data.submission;
}

export async function listSubmissions(campaignId) {
  const { data } = await api.get(`/campaigns/${campaignId}/submissions`);
  return data.items;
}

export async function toggleSubmissionHelpful(campaignId, submissionId) {
  const { data } = await api.post(`/campaigns/${campaignId}/submissions/${submissionId}/helpful`);
  return data.submission;
}

export async function listMySubmissions() {
  const { data } = await api.get(`/campaigns/mine/submissions`);
  return data.items;
}

// ----- Admin ---------------------------------------------------------------
export async function adminModerationSummary() {
  const { data } = await api.get(`/admin/moderation/summary`);
  return data;
}
export async function adminListSubmissions(status) {
  const q = status ? `?status=${status}` : "";
  const { data } = await api.get(`/admin/moderation/submissions${q}`);
  return data;
}
export async function adminModerate(submissionId, status, reason) {
  const { data } = await api.patch(`/admin/moderation/submissions/${submissionId}`, { status, reason });
  return data.submission;
}
